import { render, staticRenderFns } from "./SpinnerWheelWinnerPopup.vue?vue&type=template&id=3172a8a2&scoped=true&"
import script from "./SpinnerWheelWinnerPopup.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelWinnerPopup.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelWinnerPopup.vue?vue&type=style&index=0&id=3172a8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3172a8a2",
  null
  
)

export default component.exports